export default __webpack_public_path__ + "img/bhtTvBNM.5139cf7a.svg";